<template>
  <div>
    <div
      :id="'contractor-' + contractorType.id + '-recommendations'"
      style="
        margin-bottom: 30px;
        padding-bottom: 30px;
        border-bottom: 1px solid #ccc;
      "
      v-if="observationsCount > 0"
    >
      <div>
        <div class="float-right" style="text-align: right">
          <div class="light" style="font-size: 1.1em">
            {{ observationsCount }} {{ observationLabel | lowercase }} found
          </div>
          <div v-if="!showDetails">
            <a @click.prevent="showDetails = true">show details</a>
          </div>
          <template v-if="showDetails">
            <div
              :key="observation"
              v-for="observation in observationRecommendations"
            >
              <span>{{ observation.number }}</span>
              <span v-if="observation.attributes.report_item">
                {{
                  observation.attributes.report_item.attributes.name
                }}&nbsp;-&nbsp;
              </span>
              <span>{{ observation.attributes.name }}</span>
            </div>
            <a @click.prevent="showDetails = false">hide details</a>
          </template>
        </div>
        <h2 style="margin-bottom: 0px">
          <div>
            {{ recommendation.name }}
          </div>
        </h2>
        <div class="float-clear">&nbsp;</div>
      </div>
      <div
        style="padding-top: 25px"
        :key="contractor.id"
        v-for="contractor in contractorType.contractors"
      >
        <div class="float-right">
          <v-btn
            v-if="hasSubmittedQuote(contractor)"
            color="primary"
            disabled
            class="disabled"
          >
            Quote Submitted
          </v-btn>
          <v-btn
            v-if="!hasSubmittedQuote(contractor)"
            color="primary"
            @click="
              handleGetQuote({ contractor, contractorType: recommendation })
            "
          >
            Get Quote
          </v-btn>
        </div>
        <v-layout wrap>
          <v-flex md2 xs2>
            <div
              style="
                width: 130px;
                background: whiteSmoke;
                text-align: center;
                padding: 15px 20px;
              "
              v-if="!contractor.attributes.logo_url"
            >
              <i
                class="fa fa-building"
                style="font-size: 2.5em; color: #666"
                aria-hidden="true"
              ></i>
            </div>
            <img
              v-if="contractor.attributes.logo_url"
              :src="contractor.attributes.logo_url"
              style="width: 130px; border: 1px solid whiteSmoke"
            />
          </v-flex>
          <v-flex xs10>
            <div style="margin-left: 10px">
              <div style="font-size: 1.4em">
                {{ contractor.attributes.first_name }}
                {{ contractor.attributes.last_name }}
              </div>
              <div style="font-size: 1.1em">
                <template v-if="contractor.attributes.website">
                  <a
                    :href="formatUrl(contractor.attributes.website)"
                    target="_BLANK"
                  >
                    {{
                      contractor.attributes.company_name ||
                      contractor.attributes.website
                    }}
                  </a>
                </template>
                <template v-if="!contractor.attributes.website">
                  {{ contractor.attributes.company_name }}
                </template>
              </div>
              <div style="font-size: 1.1em; margin-top: 5px">
                <div>{{ contractor.attributes.phone }}</div>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </div>
    </div>
  </div>
</template>

<script>
import pluralizeWithCount from '@/utils/pluralizeWithCount'
import { mapState } from 'vuex'
import formatUrl from '@/utils/formatUrl'

export default {
  props: {
    contractorType: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    showDetails: false,
  }),
  computed: {
    ...mapState('reports', [
      'observations',
      'report',
      'reportContractors',
      'recommendations',
    ]),

    defectsLabel() {
      return this.report.attributes.settings.deficiencies_label
    },

    observationsCount() {
      return this.observationRecommendations.length
    },

    observationLabel() {
      return pluralizeWithCount(this.observationsCount, this.defectsLabel)
    },

    observationRecommendations() {
      return this.observations
        .filter(
          (observation) =>
            !['limit', 'info'].includes(observation.attributes.comment_type)
        )
        .filter(
          (obseration) =>
            obseration.attributes.recommendation_id === this.contractorType.id
        )
    },

    recommendation() {
      const recommendation = this.recommendations.find(
        (result) => result.attributes.id === this.contractorType.id
      )

      if (!recommendation) {
        return {}
      }

      return recommendation && recommendation.attributes
    },
  },
  methods: {
    formatUrl,
    handleGetQuote({ contractor, contractorType }) {
      this.$emit('getQuote', {
        contractor: {
          ...contractor,
          contractorType,
          report_id: this.report.id,
          inspection_id: this.report.inspection_id,
          observations: this.observationRecommendations,
          observationLabel: this.observationLabel,
        },
      })
    },
    hasSubmittedQuote(contractor = {}) {
      const types = contractor.attributes.lead_types_submitted || []

      return types.includes(this.contractorType.id)
    },
  },
}
</script>

<style></style>
